angular.module('tf.services')

    .factory('ConversionService', ['$rootScope', '$timeout','StorageService', function ($rootScope, $timeout, StorageService) {
        var service = {};

        //var converting = {};//{path : date}
        //var creating = {}; //{parent : {id : {created_time : date , asset : asset}}, id : {created_time : date , asset : asset}}}
        var conversionTimeout = 60000;


        function cleanConverting(){
            StorageService.load('converting').then(function(converting){
                converting = converting || {};
                var date = (new Date()).getTime();
                converting = _.omit(converting, function(value){
                    return date - value > conversionTimeout;
                });
                StorageService.store('converting', converting);
            });
        }
        function cleanCreating(){
            StorageService.load('creating').then(function(creating){
                creating = creating || {};
                var date = (new Date()).getTime();

                creating = _.omit(creating, function(value){
                    value = _.omit(value, function(val){
                        return date - val.created_time > conversionTimeout;
                    });
                    return _.isEmpty(value);
                });
                StorageService.store('creating', creating);
            });
        }
        function init(){
            cleanConverting();
            cleanCreating();
        }
        init();

        function saveConverting(paths){
             StorageService.load('converting').then(function(converting){
                 converting = converting || {};
                 var date = (new Date()).getTime();
                 _.each(paths, function(path){
                     converting[path] = date;
                 });
                 StorageService.store('converting', converting);
             });
        }
        function saveCreating(parent, asset){
            StorageService.load('creating').then(function(creating){
                creating = creating || {};
                var date = (new Date()).getTime();
                if(parent in creating){
                    creating[parent][asset.id] = {created_time : date , asset : asset};
                } else {
                    var obj = {};
                    obj[asset.id] = {created_time : date , asset : asset};
                    creating[parent] = obj;
                }
                StorageService.store('creating', creating);
            });
        }
        function setIfCreating(parent, items, scope){
            StorageService.load('creating').then(function(creating){
                creating = creating || {};
                var date = (new Date()).getTime();
                var assets = creating[parent];
                if(assets){
                    _.each(assets, function(value){
                       if(date - value.created_time < conversionTimeout){
                           var item = {type : value.asset.type, name : value.asset.name, path : value.asset.id, url : value.asset.url, converting : true};
                           items.push(item);
                           scope.$apply();
                           $timeout(function(){
                               if(item.converting){
                                   delete item.converting;
                                   scope.$apply();
                               }

                           }, conversionTimeout);
                       } else {
                           delete creating[parent][value.id];
                       }
                    });
                    if(_.isEmpty(assets)){
                        delete creating[parent];
                    }
                }
                StorageService.store('creating', creating);
            });
        }
        function removeCreating(parent, asset){
            StorageService.load('creating').then(function(creating){
                creating = creating || {};
                if(creating[parent]){
                    delete creating[parent][asset.id];
                }
                StorageService.store('creating', creating);
            });
        }
        function removeConverting(paths){
            StorageService.load('converting').then(function(converting){
                converting = converting || {};
                _.each(paths, function(path){
                    delete converting[path];
                });
                StorageService.store('converting', converting);
            });
        }
        function setIfConverting(items, scope){
            StorageService.load('converting').then(function(converting){
                converting = converting || {};
                var date = (new Date()).getTime();
                _.each(items, function(item){
                    if(converting[item.path] && date - converting[item.path] < conversionTimeout){
                        item.converting = true;
                        scope.$apply();
                        $timeout(function(){
                            if(item.converting){
                                delete item.converting;
                                scope.$apply();
                            }

                        }, conversionTimeout);
                    } else {
                        delete converting[item.path];
                    }
                });
                StorageService.store('converting', converting);
            });
        }

        $rootScope.$on('converting', function(event, data){
            var paths = _.pluck(data.breadcrumbs, 'id');
            paths.push(data.id);
            var parent = paths[paths.length - 2];

            saveConverting(paths);
            //saveCreating(parent, data);

        });

        $rootScope.$on('converted', function(event, data){
            var paths = _.pluck(data.breadcrumbs, 'id');
            paths.push(data.id);
            var parent = paths[paths.length - 2];
            removeConverting(paths);
            //removeCreating(parent, data);
        });

        function addNewProject(data, items, parent){

            if(data.content && data.content.type === 2 && parent === data.breadcrumbs[data.breadcrumbs.length -1].id){
                items.push({type : data.content.type, name : data.content.name, path : data.content.id, url : data.content.url, converting : true});
                return true;
            } else {
                return false;
            }
        }


        service.listen = function(scope, items){



            var parent = items.breadcrumbs? items.breadcrumbs[items.breadcrumbs.length-1].id : '';
            items = items.content || items;
            setIfConverting(items, scope);
            //setIfCreating(parent, items, scope);



            scope.$on('converting', function(event, data){

                var paths = _.pluck(data.breadcrumbs, 'id');
                paths.push(data.id);

                _.each(items, function(item){
                    if(paths.indexOf(item.path) !== -1) {
                        item.converting = true;
                        setTimeout(function(){
                            item.converting = false;
                            scope.$apply();
                        },conversionTimeout);
                    }
                });
                addNewProject(data, items, parent);
                scope.$apply();

            });
            scope.$on('converted', function(event, data){

                var paths = _.pluck(data.breadcrumbs, 'id');
                paths.push(data.id);

                _.each(items, function(item){
                    if(paths.indexOf(item.path) !== -1) {
                        item.converting = false;
                        item.url = data.content.url;
                        scope.$apply();
                    }
                });
            });
        };

        return service;
    }])
;
